import React from "react";
import "../../page_content.css";

const MaritimeDay = () => {
  return (
    <div>
      <h1 className="title">National Maritime Day</h1>
      <hr />
      <div className="page-content-gallery">
        <img
          src="/assets/images/National Maritime Day/nm_1.webp"
          alt="Award 1"
          className="award-img"
        />
        <img
          src="/assets/images/National Maritime Day/nm_2.webp"
          alt="Award 2"
          className="award-img"
        />
      </div>
      <p>
        National Maritime Day is celebrated on 5th of April. This day is
        celebrated in the honor of "SS LOYALTY," the first ship of the Scandia
        Steam Navigation Company. This auspicious day symbolizes the hard work
        of sailors. It flaunts sailors' zeal to overcome adverse conditions with
        limited resources, their team spirit, and determination backed up by
        their hopes. Every year, senior cadets organize the National Maritime
        Day event. They decorate the college auditorium and plan out mesmerizing
        events. The function starts with a dance performance, various bands'
        performance, reciting poems followed by singers pouring out their souls
        into music.
      </p>
      <p>
        The event ends with the prize distribution to cadets excelling in
        co-curricular activities. The combined efforts of the organizers,
        performers, and the spectators result in marking the event as one of the
        memorable days on the calendar of MANET.
      </p>
    </div>
  );
};

export default MaritimeDay;
